import script from "./RecommendationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationsView.vue?vue&type=script&setup=true&lang=js"

import "./RecommendationsView.vue?vue&type=style&index=0&id=428a504f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428a504f"]])

export default __exports__